export const EXPENSES_REQUESTS = 'expensesRequests';
export const CHECK_EXPENSES = 'checkExpenses';
export const CREDIT_CARDS_REQUEST = 'creditCardsRequest';
export const CREDIT_CARDS_SUCCESS = 'creditCardsSuccess';
export const CREDIT_CARDS_LOADING = 'creditCardsLoading';
export const CREDIT_CARDS_ERROR = 'creditCardsError';
export const POST_NEW_CREDIT_CARD = 'postNewCreditCard';
export const NEW_CREDIT_CARD_SUCCESS = 'newCreditCardSuccess';
export const DELETE_CREDIT_CARD = 'deleteCreditCard';
export const DELETE_CREDIT_CARD_SUCCESS = 'deleteCreditCardSuccess';
export const EDIT_CREDIT_CARD = 'editCreditCard';
export const EDIT_CREDIT_CARD_SUCCESS = 'editCreditCardSuccess';
export const REQUEST_CREDIT_CARD_ITEM = 'requestCreditCardItem';
export const CREDIT_CARD_ITEM_SUCCESS = 'creditCardItemSuccess';
export const ACCOUNTS_LOADING = 'accountsLoading';
export const ACCOUNTS_ERROR = 'accountsError';
export const REQUEST_CREDIT_ACCOUNTS = 'requestCreditAccounts';
export const CREDIT_ACCOUNTS_SUCCESS = 'creditAccountsSuccess';
export const POST_NEW_CREDIT_ACCOUNT = 'postNewCreditAccount';
export const NEW_CREDIT_ACCOUNT_SUCCESS = 'newCreditAccountSuccess';
export const DELETE_CREDIT_ACCOUNT = 'deleteCreditAccount';
export const DELETE_CREDIT_ACCOUNT_SUCCESS = 'deleteCreditAccountSuccess';
export const EDIT_CREDIT_ACCOUNT = 'editCreditAccount';
export const EDIT_CREDIT_ACCOUNT_SUCCESS = 'editCreditAccountSuccess';
export const REQUEST_CREDIT_ACCOUNT_ITEM = 'requestCreditAccountItem';
export const REQUEST_CREDIT_ACCOUNT_ITEM_SUCCESS = 'requestCreditAccountItemSuccess';
export const REQUEST_INVESTMENT_ACCOUNTS = 'requestInvestmentAccounts';
export const INVESTMENT_ACCOUNTS_SUCCESS = 'investmentAccountsSuccess';
export const POST_NEW_INVESTMENT_ACCOUNT = 'postNewInvestmentAccount';
export const NEW_INVESTMENT_ACCOUNT_SUCCESS = 'newInvestmentAccountSuccess';
export const DELETE_INVESTMENT_ACCOUNT = 'deleteInvestmentAccount';
export const DELETE_INVESTMENT_ACCOUNT_SUCCESS = 'deleteInvestmentAccountSuccess';
export const EDIT_INVESTMENT_ACCOUNT = 'editInvestmentAccount';
export const EDIT_INVESTMENT_ACCOUNT_SUCCESS = 'editInvestmentAccountSuccess';
export const REQUEST_INVESTMENT_ACCOUNT_ITEM = 'requestInvestmentAccountItem';
export const REQUEST_INVESTMENT_ACCOUNT_ITEM_SUCCESS = 'requestInvestmentAccountItemSuccess';
export const REQUEST_CRYPTOCURRENCY_ACCOUNTS = 'requestCryptocurrencyAccounts';
export const CRYPTOCURRENCY_ACCOUNTS_SUCCESS = 'cryptocurrencyAccountsSuccess';
export const POST_NEW_CRYPTOCURRENCY_ACCOUNT = 'postNewCryptocurrencyAccount';
export const NEW_CRYPTOCURRENCY_ACCOUNT_SUCCESS = 'newCryptocurrencyAccountSuccess';
export const DELETE_CRYPTOCURRENCY_ACCOUNT = 'deleteCryptocurrencyAccount';
export const DELETE_CRYPTOCURRENCY_ACCOUNT_SUCCESS = 'deleteCryptocurrencyAccountSuccess';
export const EDIT_CRYPTOCURRENCY_ACCOUNT = 'editCryptocurrencyAccount';
export const EDIT_CRYPTOCURRENCY_ACCOUNT_SUCCESS = 'editCryptocurrencyAccountSuccess';
export const REQUEST_CRYPTOCURRENCY_ACCOUNT_ITEM = 'requestCryptocurrencyAccountItem';
export const REQUEST_CRYPTOCURRENCY_ACCOUNT_ITEM_SUCCESS = 'requestCryptocurrencyAccountItemSuccess';
export const REQUEST_FOOD_AND_HOUSING = 'requestFoodAndHousing';
export const FOOD_AND_HOUSING_SUCCESS = 'foodAndHousingSuccess';
export const FOOD_AND_HOUSING_LOADING = 'foodAndHousingLoading';
export const FOOD_AND_HOUSING_ERROR = 'foodAndHousingError';
export const POST_FOOD_AND_HOUSING = 'postFoodAndHousing';
export const REQUEST_TRANSPORTATION_AND_MEDICAL = 'requestTransportationAndMedical';
export const TRANSPORTATION_AND_MEDICAL_SUCCESS = 'transportationAndMedicalSuccess';
export const TRANSPORTATION_AND_MEDICAL_LOADING = 'transportationAndMedicalLoading';
export const TRANSPORTATION_AND_MEDICAL_ERROR = 'transportationAndMedicalError';
export const POST_TRANSPORTATION_AND_MEDICAL = 'postTransportationAndMedical';
export const REQUEST_OTHER_LIVING_EXPENSES = 'requestOtherLivingExpenses';
export const OTHER_LIVING_EXPENSES_SUCCESS = 'otherLivingExpensesSuccess';
export const OTHER_LIVING_EXPENSES_LOADING = 'otherLivingExpensesLoading';
export const OTHER_LIVING_EXPENSES_ERROR = 'otherLivingExpensesError';
export const POST_OTHER_LIVING_EXPENSES = 'postOtherLivingExpenses';
export const POST_ADDITIONAL_EXPENSES_FILES = 'postAdditionalExpensesFiles';
export const POST_ADDITIONAL_FILES_SUCCESS = 'postAdditionalFilesSuccess';
export const GET_ADDITIONAL_EXPENSES_FILES = 'getAdditionalExpensesFiles';
export const GET_ADDITIONAL_FILES_SUCCESS = 'getAdditionalFilesSuccess';
export const DELETE_ADDITIONAL_EXPENSES_FILES = 'deleteAdditionalExpensesFiles';
export const DELETE_FILES_SUCCESS = 'deleteFilesSuccess';
export const FOOD_AND_HOUSING_CALCULATIONS_REQUEST = 'foodAndHousingCalculationsRequest';
export const VEHICLE_CALCULATIONS_REQUEST = 'vehicleCalculationsRequest';
export const VEHICLE_CALCULATIONS_REQUEST_SUCCESS = 'vehicleCalculationRequestSuccess';
export const TRANSPORT_CALCULATIONS_REQUEST = 'transportCalculationsRequest';
export const TRANSPORT_CALCULATIONS_REQUEST_SUCCESS = 'transportCalculationsRequestSuccess';
export const MEDICAL_CALCULATIONS_REQUEST = 'medicalCalculationsRequest';
export const MEDICAL_CALCULATIONS_REQUEST_SUCCESS = 'medicalCalculationsRequestSuccess';
export const DOWNLOAD_FILE = 'downloadFile';
